import React from "react";
import { OtpTextfield } from "./OtpTextfield";
import otpContentData from "./data/otpContent";
import Terms from "./Terms";

interface OtpVerificationScreenProps {
  email: string;
  otpCode: string;
  hasError: boolean;
  onOtpChange: (code: string) => void;
  onVerify: () => void;
  onResend: () => void;
}

// OTP Header Component
const OtpHeader: React.FC<{ email: string }> = ({ email }) => {
  const subtitle = otpContentData.otp.subtitle.replace("<at mail.com>", email);

  return (
    <div className="otp-header">
      <div className="otp-title">{otpContentData.otp.title}</div>
      <div className="otp-subtitle">{subtitle}</div>
    </div>
  );
};

// Primary Button Component
const PrimaryButton: React.FC<{
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}> = ({ onClick }) => {
  return (
    <button
      className="primary-button"
      onClick={(e) => {
        e.preventDefault();

        onClick(e);
      }}
    >
      <span className="primary-button-text">
        {otpContentData.otp.buttonText}
      </span>
    </button>
  );
};

// Divider Component
const Divider: React.FC = () => {
  return (
    <div className="divider">
      <div className="divider-line" />
    </div>
  );
};

// Resend Text Component
const ResendText: React.FC<{ hasError: boolean; onResend: () => void }> = ({
  hasError,
  onResend,
}) => {
  const textColor = hasError ? "#e5484d" : "#84828e";
  const resendText = hasError
    ? otpContentData.otp.errorText
    : otpContentData.otp.resendText;

  return (
    <div className="resend-text" style={{ color: textColor }}>
      <span>{resendText} </span>
      <span className="resend-link" onClick={onResend}>
        {otpContentData.otp.resendLink}
      </span>
    </div>
  );
};

// OTP Form Component
const OtpForm: React.FC<OtpVerificationScreenProps> = ({
  email,
  otpCode,
  hasError,
  onOtpChange,
  onVerify,
  onResend,
}) => {
  const handleOtpChange = (value: string) => {
    onOtpChange(value);
  };

  return (
    <div className="otp-form-container">
      <OtpHeader email={email} />
      <Divider />
      <form
        className="form-group"
        onSubmit={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <OtpTextfield
          label={otpContentData.otp.codeLabel}
          placeholder={otpContentData.otp.codePlaceholder}
          value={otpCode}
          onChange={handleOtpChange}
          hasError={hasError}
        />
        <ResendText hasError={hasError} onResend={onResend} />
        <PrimaryButton
          onClick={(e: any) => {
            e.preventDefault();
            e.stopPropagation();
            onVerify();
          }}
        />
      </form>
    </div>
  );
};

// OTP Verification Screen Component
export const OtpVerificationScreen: React.FC<OtpVerificationScreenProps> = (
  props,
) => {
  return (
    <div className="auth-panel">
      <OtpForm {...props} />
      <Terms />
    </div>
  );
};

export default OtpVerificationScreen;
